var React = require('react');

function Recur (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 7L2 5V4H9V6L12 3L9 0V2H0V7ZM12 10V5L10 7V8H3V6L0 9L3 12V10H12Z","fill":"#424242"}));
}

Recur.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Recur;

Recur.default = Recur;
